import React from 'react';
import { Calendar, Users, Briefcase, Heart, Cake, Music } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Briefcase,
      title: 'Corporate Events',
      description: 'Professional catering for meetings, conferences, and corporate functions. Reliable service for your business needs.',
      features: ['Breakfast meetings', 'Lunch buffets', 'Evening receptions']
    },
    {
      icon: Cake,
      title: 'Parties & Celebrations',
      description: 'Birthdays, anniversaries, christenings - we cater for all celebrations with delicious food and flexible packages.',
      features: ['Birthday parties', 'Anniversaries', 'Christenings']
    },
    {
      icon: Users,
      title: 'Funerals & Wakes',
      description: 'Compassionate and professional catering during difficult times. We handle all arrangements with care and respect.',
      features: ['Wake catering', 'Private venues', 'Flexible arrangements']
    },
    {
      icon: Music,
      title: 'Festivals & Events',
      description: 'Mobile catering for outdoor events, festivals, and large gatherings. Serving up to 500+ guests.',
      features: ['Festival catering', 'Street food', 'Mobile setups']
    },
    {
      icon: Calendar,
      title: 'Special Occasions',
      description: 'Afternoon teas, BBQs, hog roasts, and more. Whatever your occasion, we create memorable dining experiences.',
      features: ['Afternoon tea', 'BBQ & hog roasts', 'Themed events']
    },
    {
      icon: Heart,
      title: 'Matchday Catering',
      description: 'Professional matchday catering for football teams. We proudly serve Chadderton FC and Mancunian Unity FC.',
      features: ['Pre-match meals', 'Post-match buffets', 'Team events']
    }
  ];

  return (
    <section id="services" className="py-20" style={{ backgroundColor: 'var(--color-accent-coconut)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: 'var(--text-base)' }}>
            Our Catering Services
          </h2>
          <p className="text-xl max-w-3xl mx-auto" style={{ color: 'var(--text-subtle-light)' }}>
            From intimate gatherings to grand celebrations, we provide exceptional catering for every occasion.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg transition-all card-hover"
              >
                <div className="mb-6">
                  <div
                    className="w-14 h-14 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: 'var(--color-accent-coconut)' }}
                  >
                    <Icon size={28} style={{ color: 'var(--accent-ui-accent)' }} />
                  </div>
                </div>
                <h3 className="text-2xl font-bold mb-3" style={{ color: 'var(--text-base)' }}>
                  {service.title}
                </h3>
                <p className="mb-4" style={{ color: 'var(--text-subtle-light)' }}>
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start">
                      <span
                        className="inline-block w-1.5 h-1.5 rounded-full mt-2 mr-2"
                        style={{ backgroundColor: 'var(--accent-ui-accent)' }}
                      ></span>
                      <span style={{ color: 'var(--text-subtle-light)' }}>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg mb-6" style={{ color: 'var(--text-base)' }}>
            <strong>Capacity:</strong> We cater for events from 20 to 500+ guests
          </p>
          <p className="text-lg" style={{ color: 'var(--text-base)' }}>
            <strong>Delivery Area:</strong> Chadderton, Oldham, Rochdale, and Greater Manchester
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;